<div class="num-meta-popover__container" *transloco="let t">
  <form [formGroup]="numMetaForm">
    <xi-dropdown
      formControlName="operator"
      [data]="numericRangeDropdownData"
      (onValueChange)="onValueChange($event.detail.selected.id)"
    ></xi-dropdown>
    <div class="num-metadata-popover__numeric-value">
      @if (!isNumericRange) {
        <xi-input-field formControlName="numericValue" type="number"></xi-input-field>
      }
    </div>
    @if (isNumericRange) {
      <xi-dropdown formControlName="leftOperator" [data]="operatorDropdownData"></xi-dropdown>
      <div class="num-metadata-popover__numeric-value">
        <xi-input-field formControlName="leftNumericValue" type="number"></xi-input-field>
      </div>
      <xi-radio
        formControlName="booleanOperator"
        name="booleanOperator"
        [label]="t('numeric-metadata-popover.and-operator')"
        value="AND"
      ></xi-radio>
      <xi-radio
        formControlName="booleanOperator"
        name="booleanOperator"
        [label]="t('numeric-metadata-popover.or-operator')"
        value="OR"
      ></xi-radio>
      <xi-dropdown formControlName="rightOperator" [data]="operatorDropdownData"></xi-dropdown>
      <div class="num-metadata-popover__numeric-value">
        <xi-input-field formControlName="rightNumericValue" type="number"></xi-input-field>
      </div>
    }
  </form>

  <div class="num-metadata-popover__horizontal-line"></div>
  <div class="num-meta-popover__actions">
    <xi-default-button
      type="button"
      [text]="t('numeric-metadata-popover.cancel')"
      fill="text"
      (onClick)="onCancel()"
    ></xi-default-button>

    <xi-default-button
      [text]="t('numeric-metadata-popover.apply')"
      (onClick)="onSave()"
      [disabled]="numMetaForm.invalid"
    ></xi-default-button>
  </div>
</div>
